export const mobileHorizPadding2x = "40px";
